/* Pravelle UI: reveal, adição rápida, tabs, shop the look, gift finder */
(function () {
  'use strict';
  window.pvUI = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function reveal(root) {
    var els = root.querySelectorAll('.pv-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce || design) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (x) {
        if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pv-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function updateBubble(sections) {
    var b = document.getElementById('cart-icon-bubble');
    if (!b || !sections || !sections['cart-icon-bubble']) return;
    var d = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var inner = d.querySelector('.shopify-section');
    b.innerHTML = inner ? inner.innerHTML : d.body.innerHTML;
  }

  function addToCart(variantId, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'A adicionar'; }
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var sections = useDrawer ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    var url = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || res.d.status) throw new Error(res.d.description || res.d.message || 'Não foi possível adicionar');
        var opened = false;
        if (useDrawer) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(res.d); opened = true; } catch (e) { opened = false; }
        }
        if (!opened) { updateBubble(res.d.sections); toast('Adicionado ao carrinho'); }
        document.dispatchEvent(new CustomEvent('pv:cart-added', { detail: res.d }));
      })
      .catch(function (e) { toast(e.message || 'Não foi possível adicionar'); })
      .then(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.innerHTML = label; } });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pv-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-pv-add'), btn);
  });

  function initTabs(root) {
    root.querySelectorAll('[data-pv-tabs]').forEach(function (w) {
      if (w._pv) return; w._pv = 1;
      var tabs = [].slice.call(w.querySelectorAll('[role=tab]'));
      function sel(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(t); });
        t.addEventListener('keydown', function (e) {
          var n = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
          if (n === null) return;
          e.preventDefault();
          sel(tabs[(n + tabs.length) % tabs.length], true);
        });
      });
    });
  }

  function initLook(root) {
    root.querySelectorAll('[data-pv-look]').forEach(function (w) {
      if (w._pv) return; w._pv = 1;
      var dots = w.querySelectorAll('.pv-dot'), items = w.querySelectorAll('.pv-look__item');
      function act(i, scroll) {
        dots.forEach(function (d, j) { d.setAttribute('aria-expanded', j === i ? 'true' : 'false'); });
        items.forEach(function (it, j) { it.classList.toggle('is-active', j === i); });
        if (scroll && items[i] && window.innerWidth < 990) items[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { act(i, true); }); });
      items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { act(i, false); }); });
      if (dots.length) act(0, false);
    });
  }

  var WHO = {
    namorada: ['amor', 'casal', 'dia dos namorados', 'romântico', 'pendente coração', 'mensagem escondida'],
    mae: ['recordação', 'personalizados', 'colar com fotografia', 'animal de estimação', 'colar personalizado', 'significado', 'colar com nome'],
    amiga: ['amizade', 'presente melhor amiga', 'pulseira da amizade', 'pulseira com letra', 'inicial'],
    eu: ['minimalista', 'uso diário', 'elegante', 'anel geométrico']
  };
  var WHO_TXT = { namorada: 'a tua namorada', mae: 'a tua mãe', amiga: 'a tua melhor amiga', eu: 'ti' };
  var BUD = { b1: [0, 35.01], b2: [35, 50.01], b3: [50, 99999] };
  var BUD_TXT = { b1: 'até 35 €', b2: 'entre 35 € e 50 €', b3: 'acima de 50 €' };

  function card(p) {
    var badge = p.pct > 0 ? '<span class="pv-card__sale-badge">-' + esc(p.pct) + '%</span>' : '';
    var media = '<a class="pv-card__media" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
      (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy" width="700" height="933">' : '') +
      (p.img2 ? '<img src="' + esc(p.img2) + '" alt="" loading="lazy" width="700" height="933">' : '') + '</a>';
    var action = p.single
      ? '<button type="button" class="pv-card__add" data-pv-add="' + esc(p.variant) + '">Adicionar</button>'
      : '<a class="pv-card__add" href="' + esc(p.url) + '">Escolher opções</a>';
    var from = p.from ? 'Desde ' : '';
    var price = p.pct > 0
      ? '<s><span class="pv-sr">Preço normal </span>' + esc(p.cmpText) + '</s><span class="pv-card__now"><span class="pv-sr">Preço atual </span>' + from + esc(p.nowText) + '</span>'
      : from + esc(p.priceText);
    return '<div class="pv-card"><div class="pv-card__frame">' + badge + media + action + '</div><div class="pv-card__info"><a class="pv-card__title" href="' + esc(p.url) + '">' +
      esc(p.title) + '</a><span class="pv-card__price">' + price + '</span></div></div>';
  }

  function initFinder(root) {
    root.querySelectorAll('[data-pv-finder]').forEach(function (w) {
      if (w._pv) return; w._pv = 1;
      var data;
      try { data = JSON.parse(w.querySelector('[data-pv-data]').textContent); } catch (e) { return; }
      var state = { who: null, bud: null };
      var out = w.querySelector('[data-pv-results]'), note = w.querySelector('[data-pv-note]');
      w.querySelectorAll('[data-pv-who],[data-pv-bud]').forEach(function (b) {
        b.addEventListener('click', function () {
          var key = b.hasAttribute('data-pv-who') ? 'who' : 'bud';
          var val = b.getAttribute('data-pv-' + key);
          state[key] = state[key] === val ? null : val;
          w.querySelectorAll('[data-pv-' + key + ']').forEach(function (x) {
            x.setAttribute('aria-pressed', x.getAttribute('data-pv-' + key) === state[key] ? 'true' : 'false');
          });
          render(true);
        });
      });
      function inBudget(p) { var r = BUD[state.bud]; return p.price >= r[0] && p.price < r[1]; }
      function score(p) {
        var s = 0;
        if (state.who) WHO[state.who].forEach(function (t) { if (p.tags.indexOf(t) > -1) s += 3; });
        if (p.tags.indexOf('presente') > -1) s += 1;
        if (state.bud) s += inBudget(p) ? 100 : -100;
        return s;
      }
      function render(anim) {
        var list = data.filter(function (p) { return p.available; })
          .map(function (p) { return { p: p, s: score(p) }; })
          .sort(function (a, b) { return b.s - a.s || a.p.price - b.p.price; })
          .slice(0, 3).map(function (x) { return x.p; });
        var txt = 'As escolhas mais oferecidas';
        if (state.who || state.bud) {
          txt = 'Sugestões' + (state.who ? ' para ' + WHO_TXT[state.who] : '') + (state.bud ? ', ' + BUD_TXT[state.bud] : '');
        }
        function paint() {
          out.innerHTML = '<div class="pv-grid">' + list.map(card).join('') + '</div>';
          note.textContent = txt;
          out.classList.remove('is-busy');
        }
        if (anim && !reduce) { out.classList.add('is-busy'); setTimeout(paint, 220); } else { paint(); }
      }
      render(false);
    });
  }

  function init(root) {
    root = root || document;
    reveal(root); initTabs(root); initLook(root); initFinder(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
